import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader, EmptyState, StatCard, InactiveNotice } from "@/components/dash/Common";
import { AttendanceBadge } from "@/components/Badges";
import { FullLoader } from "@/components/ProtectedRoute";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime, isPackageActive } from "@/lib/format";

export default function StudentAttendance() {
  const { user } = useAuth();
  const { data, loading } = useApi("/student/attendance");
  if (loading) return <FullLoader />;
  return (
    <div data-testid="student-attendance-page">
      <PageHeader eyebrow="Absensi" title="Riwayat kehadiran" description="Rekap kehadiran pada kelas yang telah berlangsung." />
      {!isPackageActive(user) && <div className="mb-6"><InactiveNotice /></div>}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <StatCard dark label="Kehadiran" value={data.pct != null ? `${data.pct}%` : "-"} testid="attendance-pct" />
        <StatCard label="Hadir" value={data.hadir} />
        <StatCard label="Total kelas" value={data.total} />
      </div>
      {data.rows.length === 0 ? <EmptyState text="Belum ada riwayat kehadiran." /> : (
        <div className="rounded-lg border border-slate-200 bg-white overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>Kelas</TableHead><TableHead>Jadwal</TableHead><TableHead>Status</TableHead><TableHead>Dicatat</TableHead></TableRow></TableHeader>
            <TableBody>
              {data.rows.map((r) => (
                <TableRow key={r.class_id} data-testid={`attendance-row-${r.class_id}`}>
                  <TableCell className="font-medium">{r.title}</TableCell>
                  <TableCell>{fmtDateTime(r.start_at)}</TableCell>
                  <TableCell><AttendanceBadge status={r.status} /></TableCell>
                  <TableCell className="text-xs text-slate-500">{r.marked_at ? fmtDateTime(r.marked_at) : "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
